import React from 'react';

const Loader: React.FC = () => <div>Loading...</div>;

export default Loader;
